import React from 'react'
import Avis from '../../components/client/Avis'
import ProductScreenshot from '../../components/client/ProductScreenshot'
import ClientNavbar from '../../components/client/ClientNavbar'
import Footer from '../../components/client/Footer'
import GetStarted from '../../components/client/GetStarted'
import KpiDashboardHero from '../../components/client/KpiDashboardHero'
import FeaturesShowcase from '../../components/client/FeaturesShowcase'
import AnimatedStatsCounter from '../../components/client/AnimatedStatsCounter'
import TestimonialsCarousel from '../../components/client/TestimonialsCarousel'


const Home = () => {
  return (
    <div>
        <ClientNavbar />
        <GetStarted/>
        {/*<KpiDashboardHero/>*/}
        <FeaturesShowcase/>
        {/*<AnimatedStatsCounter/>*/}
        <TestimonialsCarousel/>
        <Footer/>
        
    </div>
    
  )
}

export default Home
